import type { ProjectProps } from "./Projects.types";

/** SCREENSHOT CAPTURE
 * Render page with chrome responsive dimensions in inspector (1782 x 999).
 * Run capture screenshot command in console. (cmd + p, >). It exports in 2x
 */

export const PROJECTS: ProjectProps[] = [
  {
    name: "NBA Represent",
    title: "NBA Rep",
    titleTwo: "resent",
    fullTitle: "NBA Represent",
    shortDescription: "Website to celebrate the NBA stars representing Canada",
    description:
      "A website that celebrates the NBA stars representing Canada. It features player stats and the NBA Represent contests for the 2025-26 season.",
    client: "Article",
    role: "Frontend development",
    year: "2025",
    coverPhotoUrl: "/images/nba-represent-cover.jpg",
    link: "https://nbarepresent.ca",
    clientLink: "https://madebyarticle.com",
    modalBg: "#5C5151",
    mediaUrls: [
      "/images/nba-represent-01.jpg",
      "/images/nba-represent-02.jpg",
      "/images/nba-represent-03.jpg",
      "/images/nba-represent-04.jpg",
      "/images/nba-represent-05.jpg",
    ],
  },
  {
    name: "Cruuunchify",
    title: "Cruuun",
    titleTwo: "chify",
    fullTitle: "Cruuunchify",
    shortDescription: "An analysis and discovery tool for spotify users",
    description:
      "A music streaming analysis and discovery tool built on Spotify's Web API. Cruunchify provides an appealing interactive experience leveraging users listening data.",
    role: "Product Engineering",
    year: "2020",
    coverPhotoUrl: "/images/cruuunchify-cover.jpg",
    link: "https://cruuunchify.com",
    modalBg: "#535E5A",
    mediaUrls: [
      "/images/cruuunchify-01.jpg",
      "/images/cruuunchify-02.jpg",
      "/images/cruuunchify-03.jpg",
      "/images/cruuunchify-04.jpg",
      "/images/cruuunchify-05.jpg",
    ],
  },
  {
    name: "Intelia",
    title: "Intelia",
    fullTitle: "Intelia",
    shortDescription:
      "Global tech team augmentation service of top-class talents",
    description:
      "Corporate website for Intelia, a tech team augumentation service provider.",
    client: "Intelia",
    clientLink: "https://intelia.io",
    role: "Frontend development",
    year: "2017",
    coverPhotoUrl: "/images/intelia-cover.jpg",
    link: "https://intelia.io",
    modalBg: "#535c5c",
    mediaUrls: [
      "/images/intelia-01.jpg",
      "/images/intelia-02.jpg",
      "/images/intelia-03.jpg",
      "/images/intelia-04.jpg",
    ],
  },
];

export const LABS: ProjectProps[] = [
  {
    name: "Pension App",
    title: "Pension",
    titleTwo: "App",
    fullTitle: "Pension App",
    shortDescription: "Concept pension provider microsite",
    description:
      "A microsite showcasing stories of customers of a concept pension provider.",
    role: "Frontend development",
    year: "2021",
    coverPhotoUrl: "/images/pension-app-cover.jpg",
    link: "https://apensionapp.richardekwonye.com",
    modalBg: "#564d4d",
    mediaUrls: [
      "/images/pension-app-01.jpg",
      "/images/pension-app-02.jpg",
      "/images/pension-app-03.jpg",
    ],
  },
  {
    name: "Controller",
    title: "Contro",
    titleTwo: "ller",
    fullTitle: "Controller",
    shortDescription: "An experiment using three JS basic geometries",
    description:
      "An experiment of DualShock 2 controller shapes using three JS basic geometries and a RectAreaLight.",
    role: "Frontend development",
    year: "2021",
    coverPhotoUrl: "/images/controller-cover.jpg",
    link: "https://pscontrols.richardekwonye.com",
    modalBg: "#535E5A",
    mediaUrls: ["/images/controller-01.jpg", "/images/controller-02.jpg"],
  },
  {
    name: "Game Dashboard",
    title: "Dash",
    titleTwo: "board",
    fullTitle: "Dashboard",
    shortDescription: "A concept video game dashboard interface",
    description:
      "A concept video game loading and interactive dashboard experience.",
    role: "Frontend development",
    year: "2018",
    coverPhotoUrl: "/images/dashboard-cover.jpg",
    link: "https://gamedashboard-a3201.web.app",
    modalBg: "#535E5A",
    mediaUrls: ["/images/dashboard-01.jpg", "/images/dashboard-02.jpg"],
  },
];

export const TOTAL_PROJECTS = PROJECTS.length;
export const TOTAL_LABS = LABS.length;
export const MODAL_EXIT_DURATION = 680;
